var app_url = 'https://app5.clyc.me/';
var cause_clicked = false;

function isVisible(e) {
    return !!( e.offsetWidth || e.offsetHeight || e.getClientRects().length );
}

function get_form_data(form){
    var data = {};
	for ( var i = 0; i < form.elements.length; i++ ) {
     	var e = form.elements[i];
     	//kvpairs.push(encodeURIComponent(e.name) + "=" + encodeURIComponent(e.value));
        data[e.name] = e.value;
	}
    return(data);
}

function insertAfter(newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
}

function httpGet(theUrl){
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open( "GET", theUrl, false ); // false for synchronous request
    xmlHttp.send( null );
    return xmlHttp.responseText;
}

function httpPost(url,data,json){
  var response;
  var xhr = new XMLHttpRequest();
  xhr.open("POST", url, false);
  if(json == null){
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(data));
  } else {
    xhr.send(data);
  }
  return xhr.responseText;
}

function app_authorized(shop){
	var url = app_url + 'clycme/authorized?shop=' + shop;
    //console.log(url);
    var response = httpGet(url);
    //console.log(response);
    response = JSON.parse(response);
    //if(response.status == 'success') return(true); else return(false);
    return(response.status == 'success' && response.displayOn == 'product');
}

function add_libraries(){
	var head = document.getElementsByTagName("head")[0];

	var script1 = document.createElement("script");
	script1.src = "https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js";
	head.appendChild(script1);
		
    var link1 = document.createElement("link");
	link1.href = "https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css";
	link1.type = "text/css";
	link1.rel = "stylesheet";
	head.appendChild(link1);
  
	var link2 = document.createElement("link");
	link2.href = app_url + "scripttags/clycme.css";
	link2.type = "text/css";
	link2.rel = "stylesheet";
	head.appendChild(link2);
  
    var waitForJQuery = setInterval(function () {
	    if (typeof $ != 'undefined') {
	        clearInterval(waitForJQuery);
			
            var link1 = document.createElement("link");
            link1.href = "https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css";
            link1.type = "text/css";
            link1.rel = "stylesheet";
            head.appendChild(link1);

            var script3 = document.createElement("script");
            script3.src = "https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/js/bootstrap.min.js";
            head.appendChild(script3);

            var link2 = document.createElement("link");
            link2.href = app_url + "scripttags/clycme.css";
            link2.type = "text/css";
            link2.rel = "stylesheet";
            head.appendChild(link2);
	    }
	}, 10);
}

function get_cart(shop){
	var url = '/cart.js';
    //console.log(url);
    var response = httpGet(url);
    //console.log(response);
    response = JSON.parse(response);
    //if(response.status == 'success') return(true); else return(false);
    return(response);
}

function getCartModals(shop){  
    var cart = get_cart(shop);
    //console.log(cart);
    var params = {shop: shop, cart:cart}; 
    var url = app_url + 'api/clycme/cart_modals';
    var response = httpPost(url,params);
    //console.log(response);
    response = JSON.parse(response);
    //if(response.status == 'success') return(true); else return(false);
    return(response);
}

function saveCartSale(order_id,item_list,product_list,trigger_list,price_list,amount_list,cause_id,total,value,quantity_list,variant_list){
	if(cause_clicked == false){
		cause_clicked = true;
    //console.log('function saveSale called');
	//console.log('order_id: ' + order_id);
	//console.log('item_list: ' + item_list);
    //console.log('quantity_list: ' + quantity_list);
	//console.log('product_list: ' + product_list);
    //console.log('variant_list: ' + variant_list);
	//console.log('trigger_list: ' + trigger_list);
	//console.log('price_list: ' + price_list);
	//console.log('amount_list: ' + amount_list);
	//console.log('cause_id: ' + cause_id);
	//console.log('total: ' + total);
	//console.log('value: ' + value);
    var input = document.createElement("input");
    input.name = "attributes[clycme]";
    input.setAttribute("type","hidden");
    var values = {};
    values.item_list = item_list;
    values.quantity_list = quantity_list;
    values.product_list = product_list;
    values.variant_list = variant_list;
    values.trigger_list = trigger_list;
    values.price_list = price_list;
    values.amount_list = amount_list;
    values.cause_id = cause_id;
    values.total = total;
    values.value = value;
  	input.setAttribute("value",JSON.stringify(values));
    form.append(input);
    submit = true;
    target.click();
    }
}

function addCartModals(response){
    if(response.status == 'success'){
        var body = document.getElementsByTagName("body")[0];
        var pool_count = 0;
        for(var pool_id in response.pools){
            var pool = response.pools[pool_id];
            console.log('pool_id: ' + pool_id);
            var div = document.createElement("div");
            div.id = 'clycme-pool-' + pool_id;
            div.classList.add("pool-div");
            var product_images = '&nbsp;';
            var items = pool.items;
            var item_count = 0;
            for(var item_id in items){
                var item = items[item_id];
				//var style = '';
                var style = 'style="z-index:'+ pool.item_count +'"';
                if(item_count > 0){
                    style = 'style="z-index:'+ (pool.item_count - item_count) +'; margin-left: calc((' + item_count + ' /(' + pool.item_count + ' - 1) * (1/2) - 1) * 60px);"';
					product_images += '<img class="modal-product-image" src="' + item.image_url + '" ' + style +'>';
                } else {
                    product_images += '<img class="modal-product-image modal-product-image-first" src="' + item.image_url + '" ' + style +'>';
                }
                item_count++;
            }
            var heart_url = app_url + 'images/heart.png';
            var heart_style = 'style="z-index:'+ pool.item_count +'; margin-top: 40px; margin-left: -20px;"';
            if(item_count > 1){
                heart_style = 'style="z-index:'+ pool.item_count +'; margin-top: 40px; margin-left: 10px;"';
            }
			//var heart_style = '';
			product_images += '<img class="modal-product-heart-image" src="' + heart_url + '" '+ heart_style + '>';
			var product_images_div_xs_class = 'text-xs-center';
			if(item_count > 1){
				product_images_div_xs_class = 'text-xs-left';
			}
			var cause_images = '';
			var cause_pool = pool.cause_pool;
			var causes = cause_pool.causes;
            for(var i in causes){
                var cause = causes[i];
                cause_images += '<div class="cause-block col-xs-12 col-md-4" onclick="saveCartSale(\'' + response.order_id + '\',\'' + pool.item_ids_list +'\',\'' + pool.product_ids_list +'\',\'' + pool.trigger_ids_list +'\',\'' + pool.price_list +'\',\'' + pool.amount_list +'\',\'' + cause.id + '\',\'' + pool.total + '\',\'' + pool.amount + '\',\'' + pool.quantity_list +'\',\'' + pool.variant_ids_list +'\')">' +
                                    '<div class="cause-image-div col-xs-5 col-md-12" data-dismiss="modal">' + 
                                        '<div class="cause-image-div-inner">' + 	
                                            '<img class="cause-image" src="' + cause.small_image + '">' +
                                        '</div>' +
                                    '</div>' +
                                    '<div class="cause-text-div col-xs-7 col-md-12">' + 
                                        '<div class="cause-text-div-inner">' + 
                                            cause.name + 
                                        '</div>' + 
                                    '</div>' +
                                '</div>';
            }
            var heart_url2 = app_url + 'images/heart2.png';
            var heart_style2 = 'style="z-index:'+ pool.item_count +'; "';
            div.innerHTML = '<!-- Trigger/Open The Modal -->' +
            '<!--<button id="modal-btn-' + pool_id + '" class="modal-btn" href="#modal-' + pool_id + '">Open Modal</button>-->' +
            '<button type="button" id="modal-btn-' + pool_id + '" class="modal-trigger-btn btn btn-primary" data-toggle="modal" data-target="#modal-' + pool_id + '">Launch demo modal</button>' +
            '<div id="modal-' + pool_id + '" class="modal">' +
              '<!-- Modal content -->' +
              '<div class="modal-dialog modal-dialog-centered">' +
                  '<div class="modal-content">' +
                      '<div class="modal-header text-xs-center">' +
                        '<button type="button" class="close" data-dismiss="modal">&times;</button>' +
                        '<div class="col-xs-12 text-xs-center">' +
                            '<div class="product-images-div visible-xs visible-sm hidden-md col-xs-6 '+ product_images_div_xs_class +'">' + product_images + '</div>' +
                        '</div>' +
                        '<div class="product-images-div col-xs-12 col-md-2 hidden-xs hidden-sm visible-md visible-lg '+ product_images_div_xs_class +'">' + product_images + '</div>' +
                        '<div class="product-text-div col-xs-12 col-md-8">' +
                            '<p>Al escoger les productos</p>' +
                            '<p style="font-weight:bold; text-transform: uppercase;">' + pool.items_list + '</p>' +
                            '<!--<p>Apoyarermos con un total de $' + pool.amount + 'CLP a la causa que escogas</p>-->' +
                        '</div>' +
                        '<div class="product-images-div col-md-1 hidden-xs hidden-sm visible-md visible-lg '+ product_images_div_xs_class +'">' + 
                            '<img class="modal-product-heart-image2" src="' + heart_url2 + '" '+ heart_style2 + '>' +
                        '</div>' +
                      '</div>' +
                      '<div class="modal-body text-center">' +
                        '<div class="modal-body-title">Escoge 1 cause</div>' +
                        '<div class="cause-block-row">' + cause_images + '</div>' +
                      '</div>' +
                      '<div class="modal-footer text-center" style="text-align:center">' +
                        '<div class="small_note">Powered by Clycme</div>' +
                      '</div>' +
                  '</div>' +
              '</div>' + 
            '</div>';
            body.appendChild(div);
            pool_count++;
        }
        
        if(pool_count > 0){
            var waitForPools = setInterval(function () {
                var firstPool = document.querySelector('.modal-trigger-btn');
                //console.log(typeof firstPool);
                if (typeof firstPool != 'undefined') {
                    //console.log('button clicked.');
                    firstPool.click();
                    var modal = firstPool.nextSibling;
                    //console.log('id: ' + modal.id);
                    if(modal.style.display == 'block'){
                        clearInterval(waitForPools);
                    } else {
                        //console.log('modal not displayed.');
                    }
                } else {
                    //console.log('button not found.');
                }
            }, 10);
        }
        
    }
}

function saveProductSale(order_id,item_list,product_list,trigger_list,price_list,amount_list,cause_id,total,value,quantity_list,variant_list){
	if(cause_clicked == false){
		cause_clicked = true;
    //console.log('function saveSale called');
	//console.log('order_id: ' + order_id);
	//console.log('item_list: ' + item_list);
    //console.log('quantity_list: ' + quantity_list);
	//console.log('product_list: ' + product_list);
    //console.log('variant_list: ' + variant_list);
	//console.log('trigger_list: ' + trigger_list);
	//console.log('price_list: ' + price_list);
	//console.log('amount_list: ' + amount_list);
	//console.log('cause_id: ' + cause_id);
	//console.log('total: ' + total);
	//console.log('value: ' + value);
    var input = document.createElement("input");
    input.name = "properties[clycme]";
    input.setAttribute("type","hidden");
    var values = {};
    values.item_list = item_list;
    values.quantity_list = quantity_list;
    values.product_list = product_list;
    values.variant_list = variant_list;
    values.trigger_list = trigger_list;
    values.price_list = price_list;
    values.amount_list = amount_list;
    values.cause_id = cause_id;
    values.total = total;
    values.value = value;
  	input.setAttribute("value",JSON.stringify(values));
    form2.append(input);    
    var formData = new FormData(form2); 
    var response = customCheckout(shop,formData);
    console.log(response);
    if(response.status == 'success'){
      httpGet(response.checkout.web_url);
      window.location.href = response.checkout.web_url;
    }
    //submit2 = true;
    //target2.click();
    }
}

function addProductModals(response){
    if(response.status == 'success'){
        var body = document.getElementsByTagName("body")[0];
        var pool_count = 0;
        for(var pool_id in response.pools){
            var pool = response.pools[pool_id];
            console.log('pool_id: ' + pool_id);
            var div = document.createElement("div");
            div.id = 'clycme-pool-' + pool_id;
            div.classList.add("pool-div");
            var product_images = '&nbsp;';
            var items = pool.items;
            var item_count = 0;
                        for(var item_id in items){
                var item = items[item_id];
				//var style = '';
                var style = 'style="z-index:'+ pool.item_count +'"';
                if(item_count > 0){
                    style = 'style="z-index:'+ (pool.item_count - item_count) +'; margin-left: calc((' + item_count + ' /(' + pool.item_count + ' - 1) * (1/2) - 1) * 60px);"';
					product_images += '<img class="modal-product-image" src="' + item.image_url + '" ' + style +'>';
                } else {
                    product_images += '<img class="modal-product-image modal-product-image-first" src="' + item.image_url + '" ' + style +'>';
                }
                item_count++;
            }
            var heart_url = app_url + 'images/heart.png';
            var heart_style = 'style="z-index:'+ pool.item_count +'; margin-top: 40px; margin-left: -20px;"';
            if(item_count > 1){
                heart_style = 'style="z-index:'+ pool.item_count +'; margin-top: 40px; margin-left: 10px;"';
            }
			//var heart_style = '';
			product_images += '<img class="modal-product-heart-image" src="' + heart_url + '" '+ heart_style + '>';
			var product_images_div_xs_class = 'text-xs-center';
			if(item_count > 1){
				product_images_div_xs_class = 'text-xs-left';
			}
			var cause_images = '';
			var cause_pool = pool.cause_pool;
			var causes = cause_pool.causes;
            for(var i in causes){
                var cause = causes[i];
                cause_images += '<div class="cause-block col-xs-12 col-md-4" onclick="saveProductSale(\'' + response.order_id + '\',\'' + pool.item_ids_list +'\',\'' + pool.product_ids_list +'\',\'' + pool.trigger_ids_list +'\',\'' + pool.price_list +'\',\'' + pool.amount_list +'\',\'' + cause.id + '\',\'' + pool.total + '\',\'' + pool.amount + '\',\'' + pool.quantity_list +'\',\'' + pool.variant_ids_list +'\')">' +
                                    '<div class="cause-image-div col-xs-5 col-md-12" data-dismiss="modal">' + 
                                        '<div class="cause-image-div-inner">' + 	
                                            '<img class="cause-image" src="' + cause.small_image + '">' +
                                        '</div>' +
                                    '</div>' +
                                    '<div class="cause-text-div col-xs-7 col-md-12">' + 
                                        '<div class="cause-text-div-inner">' + 
                                            cause.name + 
                                        '</div>' + 
                                    '</div>' +
                                '</div>';
            }
            var heart_url2 = app_url + 'images/heart2.png';
            var heart_style2 = 'style="z-index:'+ pool.item_count +'; "';
            div.innerHTML = '<!-- Trigger/Open The Modal -->' +
            '<!--<button id="modal-btn-' + pool_id + '" class="modal-btn" href="#modal-' + pool_id + '">Open Modal</button>-->' +
            '<button type="button" id="modal-btn-' + pool_id + '" class="modal-trigger-btn btn btn-primary" data-toggle="modal" data-target="#modal-' + pool_id + '">Launch demo modal</button>' +
            '<div id="modal-' + pool_id + '" class="modal">' +
              '<!-- Modal content -->' +
              '<div class="modal-dialog modal-dialog-centered">' +
                  '<div class="modal-content">' +
                      '<div class="modal-header text-xs-center">' +
                        '<button type="button" class="close" data-dismiss="modal">&times;</button>' +
                        '<div class="col-xs-12 text-xs-center">' +
                            '<div class="product-images-div visible-xs visible-sm hidden-md col-xs-6 '+ product_images_div_xs_class +'">' + product_images + '</div>' +
                        '</div>' +
                        '<div class="product-images-div col-xs-12 col-md-2 hidden-xs hidden-sm visible-md visible-lg '+ product_images_div_xs_class +'">' + product_images + '</div>' +
                        '<div class="product-text-div col-xs-12 col-md-8">' +
                            '<p>Al escoger les productos</p>' +
                            '<p style="font-weight:bold; text-transform: uppercase;">' + pool.items_list + '</p>' +
                            '<!--<p>Apoyarermos con un total de $' + pool.amount + 'CLP a la causa que escogas</p>-->' +
                        '</div>' +
                        '<div class="product-images-div col-md-1 hidden-xs hidden-sm visible-md visible-lg '+ product_images_div_xs_class +'">' + 
                            '<img class="modal-product-heart-image2" src="' + heart_url2 + '" '+ heart_style2 + '>' +
                        '</div>' +
                      '</div>' +
                      '<div class="modal-body text-center">' +
                        '<div class="modal-body-title">Escoge 1 cause</div>' +
                        '<div class="cause-block-row">' + cause_images + '</div>' +
                      '</div>' +
                      '<div class="modal-footer text-center" style="text-align:center">' +
                        '<div class="small_note">Powered by Clycme</div>' +
                      '</div>' +
                  '</div>' +
              '</div>' + 
            '</div>';
            body.appendChild(div);
            pool_count++;
        }
        
        if(pool_count > 0){
            var waitForPools = setInterval(function () {
                var firstPool = document.querySelector('.modal-trigger-btn');
                //console.log(typeof firstPool);
                if (typeof firstPool != 'undefined') {
                    //console.log('button clicked.');
                    firstPool.click();
                    var modal = firstPool.nextSibling;
                    //console.log('id: ' + modal.id);
                    if(modal.style.display == 'block'){
                        clearInterval(waitForPools);
                    } else {
                        //console.log('modal not displayed.');
                    }
                } else {
                    //console.log('button not found.');
                }
            }, 10);
        }
        
    }
}

function getProductModals(shop,data){  
    var params = {shop: shop, data:data}; 
    var url = app_url + 'api/clycme/product_modals';
    var response = httpPost(url,params);
    //console.log(response);
    response = JSON.parse(response);
    //if(response.status == 'success') return(true); else return(false);
    return(response);
}

function customCheckout(shop,data){  
    data.append("shop", shop);
    var url = app_url + 'api/clycme/checkout';
    var response = httpPost(url,data,false);
    //console.log(response);
    response = JSON.parse(response);
    //if(response.status == 'success') return(true); else return(false);*/
    return(response);
}
